import { useEffect, useRef } from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { loadMapKitJSLibrary } from 'utils/apple-mapkit/index.web';
import { getConfigValue } from 'utils/environment';

export function useLoadAppleMapKit(): void {
  const enabledAppleMapkit = useFlag(LaunchDarklyFlag.ENABLE_APPLE_MAPKIT_WEB);
  const { mapKitWebJSToken } = getConfigValue({ key: 'apple', defaultValue: {} });
  const hasSucceeded = useRef(false);

  useEffect(() => {
    if (!enabledAppleMapkit || !mapKitWebJSToken || hasSucceeded.current) {
      return;
    }
    loadMapKitJSLibrary(mapKitWebJSToken).then(() => {
      hasSucceeded.current = true;
    });
  }, [enabledAppleMapkit, mapKitWebJSToken]);
}
